<template>
  <div class="-mx-3 flex flex-wrap md:justify-between text-center md:text-left" :class="sectionType[0] === 'events' || sectionType[0] === 'searchLanding' ? 'mb-0' : 'mb-3'">
    <div class="px-3 w-1/2 text-left" :class="sectionType[0] === 'events' || sectionType[0] === 'searchLanding' ? 'mb-0' : 'mb-3 md:mb-0'">
      <div v-if="itemsAmount > 0">
        <span class="font-normal text-primary-text pb-2">{{itemOffset + 1}} – {{itemsAmount}}</span> <span class="small-text text-grey-even-lighter">({{totalItems}})</span>
      </div>
      <div v-else>
        <span class="font-normal text-primary-text pb-2">0</span> <span class="small-text text-grey-even-lighter">(of 0)</span>
      </div>
    </div>
    <search-sorting
      :sort-by-text="sortByText"
      :sorting.sync="searchSorting"
      :options="sortingOptions"
    ></search-sorting>
  </div>
</template>

<script>
import Vue from 'vue';
import SearchSorting from './SearchSorting'

export default {
  name: 'CategorySearchMeta',
  props: {
    totalItems: {
      type: Number,
      default: 0
    },
    itemOffset: {
      type: Number,
      default: 0
    },
    elementsPerPage: {
      type: Number,
      default: 0
    },
    'sectionType': {
      type: Array,
      default: []
    },
    sortingOptions: {
      type: Array,
      default: () => [
        {
          title: 'Newest first',
          value: 'postdate desc'
        },
        {
          title: 'Oldest first',
          value: 'postdate asc'
        },
        {
          title: 'Title A-Z',
          value: 'title asc'
        },
        {
          title: 'Title Z-A',
          value: 'title desc'
        }
      ]
    },
    sortByText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchSorting: ''
    }
  },
  computed: {
    itemsAmount: function() {
     const itemsLeft = this.totalItems - this.itemOffset > this.elementsPerPage ? this.itemOffset + this.elementsPerPage : this.totalItems;

     return itemsLeft;
    }
  },
  watch: {
    searchSorting: function(val) {
      this.$emit('update:searchSorting', val)
    }
  },
  components: {
    SearchSorting
  },
};
</script>
